<template>
  <v-container id="p-postEditor__container">
    <div v-if="post.id" class="p-postEditor__mainWrapper">
      <div id="p-postEditor__content-field" class="p-postEditor__content-field">
        <slot name="contentField"></slot>
      </div>
      <div id="rightToolBar" class="p-postEditor__rightToolBar">
        <slot name="rightToolBar"></slot>
      </div>
    </div>
    <DataLoader v-else-if="fetchPostLoading" :loading="fetchPostLoading" />
    <v-row v-else>
      <PostUnavailableAlert />
    </v-row>
    <PostEditorFooter />
  </v-container>
</template>

<script>
import PostUnavailableAlert from '../parts/PostUnavailableAlert'
import PostEditorFooter from './PostEditorFooter.vue'
import { mapState } from 'vuex'
import DataLoader from '@/components/commons/DataLoader'

export default {
  components: {
    PostUnavailableAlert,
    PostEditorFooter,
    DataLoader
  },
  props: {
    fetchPostLoading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post
    })
  }
}
</script>

<style scoped lang="sass">
#p-postEditor__container
  height: 100%
  width: 100%
  position: relative
.p-postEditor
  &__mainWrapper
    display: flex
    justify-content: space-around
    @media only screen and (max-width:600px)
      display: block
  &__content-field
    padding-top: 20px
    padding-bottom: 60px
    width: calc( 100vw - 400px )
    height: 100vh
    overflow: scroll
    margin-right: 50px
    max-width: 1200px
  &__rightToolBar
    box-sizing: border-box
    padding-top: 20px
    padding-bottom: 60px
    height: 100vh
    overflow-y: scroll
    -ms-overflow-style: none
    scrollbar-width: none
    min-width: 320px
    &::-webkit-scrollbar
      display:none
</style>
